module.exports = __webpack_public_path__ + "img/vertical-phone.dc5b32f6.png";